<template>
	<div class="login-page">
		<div class="logo">
			
		</div>
		<div class="login">
			<div class="content">
				<h1>Skadessag</h1>
				<p>Udfyld formularen og klik send, så vender vi tilbage til dig.</p>
				<div class="block">
					<p>Hjalp I/andre til under flytningen?</p>
					<yes-no-view v-model="ent.details.general.assisted" />
					<p>Hvem nedpakkede og gjorde klar før flytningen?</p>
					<input type="text" v-model="ent.details.general.prepared_by">
					<p>Er flytningen fuldt betalt?</p>
					<yes-no-view v-model="ent.details.general.paid" />
					<p>Hvis nej, hvorfor ikke?</p>
					<textarea v-model="ent.details.general.why_not"></textarea>
				</div>
				<div class="block">
					<p>Hvad er gået i stykker</p>
					<p class="small">Husk købsdato samt nypris</p>
					<textarea v-model="ent.details.claim.description"></textarea>
					<p>Hvornår opdagede I skaden?</p>
					<date-select-view :label="false" v-model="ent.details.claim.when" :controller="$store.state.popupController" />
					<p>Hvor er skaden sket?</p>
					<input type="text" v-model="ent.details.claim.where">
					<p>Hvem påførte skaden?</p>
					<input type="text" v-model="ent.details.claim.who">
				</div>
				<div class="block">
					<p>Hvordan tænker I at sagen bør løses?</p>
					<textarea v-model="ent.details.solution.request"></textarea>
					<p>Er der indhentet tilbud på reparation?</p>
					<yes-no-view v-model="ent.details.solution.quotes" />
				</div>
				<div class="block">
					<p>Vis os skaden</p>
					<p class="small">Husk evt kvitteringer og tilbud</p>
					<white-file-list-view v-model="files" />
				</div>
				<div class="block">
					<p>
						Såfremt I i mellemtiden selv får udbedret skaden eller indkøber nye genstande eller dele, kan I ikke forvente at få den fulde erstatning svarende til jeres egen omkostning for det nyindkøbte. Vi og vores forsikring har adskillige samarbejdspartnere, hvorigennem der kan opnås fordelagtige rabatter ved udførsel af professionelt arbejde eller indkøb af effekter.
					</p>
				</div>
				<div :class="{ button: true, disabled: sending }" @click="send">
					Send
				</div>
				<p v-if="error" class="error">{{ error }}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				sending: false,
				ent: {
					details: {
						general: {
							assisted: false,
							prepared_by: '',
							paid: false,
							why_not: ''
						},
						claim: {
							description: '',
							when: (new Date()).format('Y-m-d'),
							where: '',
							who: ''
						},
						solution: {
							request: '',
							quotes: false
						}
					}
				},
				files: [],
				entity: {
					customer_id: 1,
					username: '',
					password: ''
				},
				error: null
			};
		},
		methods: {
			async send() {
				if (this.sending) return;
				this.sending = true;

				var form = new FormData();

				form.append('body', JSON.stringify(this.ent));
				form.append('task_id', this.$route.params.id);

				for (var i = 0; i < this.files.length; ++i) {
					form.append('file' + i, this.files[i]);
				}

				try {
					var r = await this.axios.post('/claims/user/', form);
				
					

					this.error = r.data;

					if (this.error == '') {
						alert('Vi har modtaget din anmeldelse');
					}
				} catch (err) {
					this.error = 'Der opstod en systemfejl';
				}

				this.sending = false;
			},
			login() {
				//this.error = 'Der skete en fejl under login';

				this.error = null;

				var self = this;

				this.axios
					.post('/token/', this.entity)
					.then(function (r) {
						
						self.$store.state.auth = r.data;
						localStorage.setItem('auth', r.data);

						self.axios
							.get('/me/')
							.then(function (r) {
								

								if (r.data.privileges.web_login) {
									self.$router.replace('/da');

									

									self.$store.commit('employee', r.data);
									self.$store.commit('department', r.data._embedded.department);

									self.axios
										.get('/us/departments/')
										.then(function (r) {
											self.$store.commit('departments', r.data._items);
											//self.departments = r.data._items;
										});

									
								} else {
									self.error = 'Manglende rettigheder';
									self.$store.state.auth = null;
								}					
							});		
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							self.error = r.data;
						} else if (r.status == 401) {
							self.error = r.data.message;
						} else {
							self.error = 'Der opstod en systemfejl';
						}
					});	
			}
		}
	}
</script>

<style lang="scss" scoped>
	.login-page {
		background-color: yellow;

		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 1fr 400px;

		background: url('/images/login-bg.jpg') no-repeat left center;
		background-size: cover;

		& > .logo {
			background-color: rgba(0, 0, 0, 0.5);
		}

		& > .login {
			background-color: white;
			overflow-y: auto;

			& > .content {
				padding: 55px 55px 55px 55px;
				position: relative;

				& > h1 {
					font-size: 24px;
				}

				& > p {
					margin-top: 20px;
					font-size: 12px;
					color: rgb(150, 150, 150);

					&.error {
						color: #f7223f;
					}
				}

				& > .block {
					border-bottom: 1px solid rgb(209, 209, 209);
					padding: 0 0 20px 0;

					& > p {
						margin: 20px 0 0 0;

						&.small {
							margin: 0;
							font-size: 12px;
							color: rgb(150, 150, 150);
						}
					}

					&::v-deep .edit {
						height: 40px;
					}

					&::v-deep .yes-no-view, &::v-deep .white-file-list-view {
						margin-top: 10px;
					}

					& > input, &::v-deep .edit > input, & > textarea {
						-webkit-appearance: none;
						-moz-appearance: none;
						appearance: none;

						margin-top: 10px;

						border: 1px solid rgb(209, 209, 209);
						border-radius: 3px;
						font-size: 12px;
						font-weight: 100;
						width: 100%;
						height: 30px;
						line-height: 30px;
						padding: 0 10px 0 10px;
						background-color: white;
						color: black;

						&::placeholder {
							color: rgb(168, 168, 168);
						}
					}	

					& > textarea {
						height: 100px;
					}				
				}

				& > .form {
					margin-top: 30px;

					& > input {
						-webkit-appearance: none;
						-moz-appearance: none;
						appearance: none;

						margin-top: 20px;

						border: 1px solid rgb(209, 209, 209);
						border-radius: 3px;
						font-size: 12px;
						font-weight: 100;
						width: 100%;
						height: 30px;
						line-height: 30px;
						padding: 0 10px 0 10px;

						&::placeholder {
							color: rgb(168, 168, 168);
						}
					}
				}

				& > .button {
					margin-top: 20px;
					width: 100%;
					text-align: center;
					border-radius: 3px;

					&.disabled {
						background-color: #8d8d8d;
					}
				}

				& > .moovr {
					position: absolute;
					left: 0;
					bottom: 0;
					width: 290px;
					left: 55px;
					bottom: 55px;
					text-align: center;

					& > .logo {
						width: 60%;
						margin-bottom: 20px;
					}

					& > .copyright {
						font-size: 12px;
					}
				}
			}
		}
	}

	@media only screen and (max-width: 400px) {
		.login-page {
			& > .login {
				width: 100vw;

				& > .content {
					
				}
			}
		}
	}
</style>